<template>
  <div class="page">
        <div class="mainListT cf">
            <h3  class="float-l">运动会列表</h3>
            <Button class="float-r" type="primary"  icon="md-add"  @click="addSportF">添加运动会</Button>
            <Button style="margin-right:12px" class="float-r" type="primary"  icon="ios-code-working"  @click="mergeSportF">合并运动会</Button>
            <a target="_blank"  id="historical" :href="historicalUrl"></a>
            <!-- <Button style="margin-right:12px" class="float-r" type="info" v-if="historicalRole" icon="ios-search"  @click="historical">查看历史记录</Button> -->
            <Button style="margin-right:12px" class="float-r" type="info"  icon="ios-search"  @click="historical">查看历史记录</Button>
        </div>
        <div class="TableListMain">
            <div class="search">
                <Form ref="formItem" inline :model="formItem" :label-width="108">
                    <div class="searchDiv">
                        <FormItem style="width:300px;" label="运动会名称：" prop="gameNameCHN" >
                            <Input placeholder="请输入运动会名称" v-model="formItem.gameNameCHN"></Input>
                        </FormItem>
                         <FormItem style="width:260px;" label="运动会开始时间：" prop="beginTime">
                            <DatePicker type="date"  @on-change="searchStartTime"  v-model="formItem.beginTime" format="yyyy-MM-dd"  placeholder="运动会开始时间"></DatePicker>
                        </FormItem>
                        <FormItem style="width:260px;" label="运动会结束时间：" prop="endTime">
                            <DatePicker type="date"  @on-change="searchEndTime"  v-model="formItem.endTime"  format="yyyy-MM-dd" placeholder="运动会结束时间" ></DatePicker>
                        </FormItem>
                        <Button type="info" @click="searchSubmit" icon="ios-search" >搜索</Button>
                    </div>
                </Form>
            </div>
            <div class="TableList">
                <Table  stripe border :columns="registerColumns" :data="registerData" @on-selection-change="checkBoxs"></Table>
            </div>
            <Page  :total="total_record" :page-size="pag.page_size" class="sportermeetingPage"  :current="pag.page_no" @on-change="changepage"  show-elevator  show-total  placement="top"/>
        </div>
        <Modal
            :mask-closable="false"
            v-model="ModalSport"
            :title="ModalSportTi"
            width="960"
            :footerHide="true"
            @on-cancel="handleReset('formValiEditDateSports')"
        >
            <Form  ref="formValiEditDateSports" :model="formValiEditDateSports" :rules="ruleValidateSports" :label-width="180" class="editCss">
                <div class="editDiv">
                    <div class="fromDiv" >
                        <div class="fromDiv_l cf">
                            <div class="fromDiv_ll">
                                <FormItem label="运动会中文名称：" prop="gameNameCHN">
                                    <Input @on-blur="filterGameNameCHN"  placeholder="" v-model="formValiEditDateSports.gameNameCHN"></Input>
                                </FormItem>
                                <FormItem label="比赛所在地中文名称：" prop="gameSiteCHN">
                                    <Input  placeholder="" v-model="formValiEditDateSports.gameSiteCHN"></Input>
                                </FormItem>
                                
                                <FormItem label="运动会开始时间：" prop="beginTime">
                                    <DatePicker type="date" style="width:246px;"  :clearable="false" :options="startTimeOptions1" @on-change="startTimeChange1" format="yyyy-MM-dd" :value="$PlugIn.formatDateTime(formValiEditDateSports.beginTime)" placeholder="运动会开始时间"></DatePicker>
                                </FormItem>
                                <FormItem label="国际/国内：" prop="nationType">
                                    <Select v-model="formValiEditDateSports.nationType">
                                        <Option v-for="item in $PlugIn.GameTypeData1" :value="item.value" :key="item.value">{{ item.label }}</Option>
                                    </Select>
                                </FormItem>
                                <FormItem label="比赛级别：" prop="matchLevel">
                                    <Select style="width:160px;" v-model="formValiEditDateSports.matchLevel">
                                        <Option v-for="item in $PlugIn.GameTypeData3" :value="item.value" :key="item.value">{{ item.label }}</Option>
                                    </Select>
                                    <span @click="handleView" style="color:#2db7f5">（级别说明）</span>
                                </FormItem>
                            </div>
                            <div class="fromDiv_rl">
                                <FormItem label="运动会英文名称：" prop="gameNameENG">
                                        <Input   placeholder="" v-model="formValiEditDateSports.gameNameENG"></Input>
                                </FormItem>
                                
                                <FormItem label="比赛所在地英文名称：" prop="gameSiteENG">
                                        <Input   placeholder="" v-model="formValiEditDateSports.gameSiteENG"></Input>
                                </FormItem>
                                
                                <FormItem label="运动会结束时间：" prop="endTime">
                                    <DatePicker type="date" style="width:246px;" :clearable="false" :options="endTimeOptions1" @on-change="endTimeChange1" format="yyyy-MM-dd" placeholder="运动会结束时间" :value="$PlugIn.formatDateTime(formValiEditDateSports.endTime)"></DatePicker>
                                </FormItem>
                                 <FormItem label="赛事类型：" prop="areaType">
                                    <Select v-model="formValiEditDateSports.areaType">
                                        <Option v-for="item in $PlugIn.GameTypeData2" :value="item.value" :key="item.value">{{ item.label }}</Option>
                                    </Select>
                                </FormItem>
                                <FormItem label="2017以后：" v-if="historicalRole" prop="sporterLimit">
                                    <Select v-model="formValiEditDateSports.sporterLimit">
                                        <Option v-for="item in sporterLimitData" :value="item.value" :key="item.value">{{ item.label }}</Option>
                                    </Select>
                                </FormItem>
                                <FormItem label="备注信息：" prop="gameNote">
                                        <Input   placeholder="" v-model="formValiEditDateSports.gameNote"></Input>
                                </FormItem>
                            </div> 
                        </div>
                        
                    </div>
                    <div class="cf sporterEventList">
                       
                            <div style="border-bottom: 1px solid #e9e9e9;padding-bottom:6px;margin-bottom:6px;">
                                <Checkbox :indeterminate="indeterminate" :value="checkAll" @click.prevent.native="handleCheckAll">全选</Checkbox>
                                <span style="color:#999;">（请勾选运动会所属的项目）</span>
                            </div>
                            <CheckboxGroup v-model="checkAllGroup" @on-change="checkAllGroupChange">
                                <Checkbox v-for="(item,index) in eventLists" :key="index" :label="item.name"></Checkbox>
                            </CheckboxGroup>
                    </div>
                    

                    <div class="UpBut">
                        <Button class="m-r10px" type="primary" size="large" :disabled="disableds"   @click="editOk('formValiEditDateSports')">保存</Button>
                        <Button  size="large"   @click="handleReset('formValiEditDateSports')">重置</Button>
                    </div>
                    
                </div>
            </Form>
        </Modal>
        <Modal
            class="ModalSportFilter"
            :mask-closable="false"
            v-model="ModalSportFilter"
            title="时间相近运动会列表"
            width="760"
            @on-cancel="disableds=false"
            :footerHide="true"
        >
             <Table :loading="loading"  stripe border :columns="registerColumnsFilter" :data="registerDataFilter" @on-selection-change="checkBoxs"></Table>
             <p class="note">注：（上面如果有你要创建的运动会，那么可以勾选运动会，点击“去查找”按钮可以找到你所选的运动会。）</p>
             <div class="UpBut">
                <Button class="float-l" type="primary" size="large"   @click="SportFilter()">去查找</Button>
                <Button  size="large" type="info"  @click="addSportListF"  >继续保存运动会</Button>
            </div>
        </Modal>
        <Modal :styles="{top: '10px'}" width="1000" style="text-align:center;" title="比赛级别说明" v-model="visible">
            <img  :src="matchLevelImg" v-if="visible" style="max-width:960px">
        </Modal>
        <merge-modal :mergeSport="mergeSport" @upData="upSportData" v-if="mergeSport.mergeModal"></merge-modal>
        <group v-if="group.ModalGroupList" :gameId="setting.gameId" @GroupregisterDataUp="GroupregisterDataUps" :group="group" @GroupList="GroupListData"  @sexGroupListShow="ModalsexGroupListF" :setting="setting"></group>
        <sex-group v-if="sexGroup.ModalsexGroupList" @SexsortregisterDataUp="SexsortregisterDataUps" :gameId="setting.gameId" :sexGroup="sexGroup" @sexGroupList="sexGroupList"  @eventListShow="eventListShowFn" @groupListShow="groupListShowF" :setting="setting"></sex-group>
        <events v-if="eventList.ModalEvent" @showModalEvent="showModalEventF" :gameId="setting.gameId" :sexGroup="sexGroup" :event-list="eventList" :setting="setting"  @resultShow="resultShowF"  @groupListShow="groupListShowF1" ></events>
        <result-list  v-if="resultList.ModalResultList" :gameId="setting.gameId" :resultListData="resultListData"  :event-list="eventList" :sexGroup="sexGroup" :result-list="resultList" :setting="setting" @sexGroupList="sexGroupList" @resultFormShow="resultFormShowF"   @eventListShow="eventListShowFn"  @groupListShow="group.ModalGroupList = true"  ></result-list>
        <result-form :register-year="registerYear" :stampTiemY="stampTiemY" :sporterLimits="sporterLimits"  @ModalResultListShow="ModalResultListShowF" @imageUrlUp="imageUrlUps" @resultUp="resultUp" :gameId="setting.gameId"  :group="group" :result-form="resultFormObj"  :setting="setting"   ></result-form>
  </div>
</template>

<script>
import {addSportList,getSportList,getSort,getSexsortList,getEventList,internal,getEventListGameID,findByGameNameOrBeginTime,updatestate,redirectToken,countAuditInfo,currentTimes} from '@/lib/api/index.js'
import group from '@/components/group.vue'
import events from '@/components/event.vue'
import resultList from '@/components/resultList.vue'
import resultForm from '@/components/result.vue'
import sexGroup from '@/components/sexGroup.vue'
import mergeModal from '@/components/mergeModal.vue'


let requiredStr = '必选项不能为空！'
export default {
   computed: {
      historicalRole()
      {
          console.log(JSON.parse(localStorage.authorities),this.$PlugIn.role.admin)
          return JSON.parse(localStorage.authorities)==this.$PlugIn.role.admin;
      },
   },
   components: {
      group,
      events,
      resultList,
      resultForm,
      sexGroup,
      mergeModal
  },
  data(){
    return {
        sporterLimits:0,
        stampTiem:'',
        stampTiemY:'',//获取当前年份
        registerYear:0,
        visible:false,
        matchLevelImg:require('@/assets/img/matchLevelImg.jpg'),
        eventDefaultLists:[],//默认全部项目选中
        mergeSport:{//合并运动会模态框
            mergeModal:false,
            obj:'',
            mergeSportColumns:[]
        },
        eventLists:[],
        indeterminate: true,
        checkAll: false,
        checkAllGroup: [],
        loading:true,
        historicalUrl:'',
        updSporterData:{},//运动会信息
        ModalSportTi:'',
        //成绩录入
        resultFormObj:{
          ModalResultList:false,
          sexSortEventLayerID:'',
          sexSortEventID:'',
          eventList:[],
          layer:'',
          event:'',
          imageUrl:''
        },
        //成绩录入
        resultList:{
          ModalResultList:false,
        },
        resultListData:'',
        //成绩录入
        //组别
        group:{
          ModalGroupList:false,
          GroupregisterData:[]
        },
         //组别
         //比赛组别
        sexGroup:{
          ModalsexGroupList:false,
          SexsortregisterData:[],
          GroupListData:[]
        },
        //比赛组别
        //项目列表
        eventList:{
          ModalEvent:false,
          eventListData:[],
          
        },
        //项目列表
        setting:{
            modalSetting:false,
            gameId:''
        },
        sporterDetaiData:{},//查看运动会详情的数据
        ModalSportDetails:false,//运动会详情
        multipleSelection:[],//选中的列表
        disableds:false,
        // 新增运动会
        ModalSport:false,//新增运动会模态框开关
        sporterLimitData:[
            {
                label:'是',
                value:0
            },
            {
                label:'否',
                value:1
            },
        ],
        formValiEditDateSports: {//运动会基本信息
            matchLevel:'',
            nationType:0,
            areaType:0,
            gameNameCHN:'',
            gameNameCHNScreen:'',
            gameNameCHNShort:'',
            gameNameCHNScoreBoardShort:'',
            gameSiteCHN:'',
            gameLocationCHN:'',
            gameAreaCHN:'',
            gameNationCHN:'',
            beginTime:'',
            gameType:'',
            gameNameENG:'',
            gameNameENGScreen:'',
            gameNameENGShort:'',
            gameNameENGScoreBoardShort:'',
            gameSiteENG:'',
            gameLocationENG:'',
            gameAreaENG:'',
            gameNationENG:'',
            endTime:'',
            gameNote:'',
            eventLists:[],
            sporterLimit:0
        },
        ruleValidateSports:{//运动会基本信息验证
            gameNameCHN: [
                { required: true, message: requiredStr, trigger: 'blur' }
            ],
            gameSiteCHN: [
                { required: true, message: requiredStr, trigger: 'blur' }
            ],  
            gameType:[
                { required: true, message: requiredStr, trigger: 'blur' ,type: 'number'}
            ],
            beginTime:[
                { required: true, type: 'date', message: requiredStr,trigger:'change'}
            ],
            endTime:[
                { required: true, type: 'date', message: requiredStr,trigger:'change'}
            ],
            matchLevel: [
                { required: true, message: requiredStr, trigger: 'change' }
            ]
        },
        startTimeOptions1: {}, //运动会开始日期设置
        endTimeOptions1: {}, //运动会结束日期设置
        starttime1:'',
        endtime1:'',
        // 新增运动会
        pag:{//分页
            page_no: 1,
            page_size:  10,
            beginTime:'',
            endTime:'',
            gameNameCHN:'',
            sourceType:1
        },
        formItem:{//分页
            page_no: 1,
            beginTime:'',
            endTime:'',
            page_size:  10,
            gameNameCHN:'',
            sourceType:1
        },
        total_record:0,//总条数
        registerColumns: [
             {
                type: 'selection',
                width: 40,
                align:'center',
            },
            {
                type:'index',
                title: '序号',
                width:50,
                align:'center',

            },
            {
                title: '运动会名称',
                key: 'gameNameCHN',
                
            },
            {
                title: '比赛所在地名称',
                key: 'gameSiteCHN',
            },
            
            {
                title: '开始时间',
                key: 'beginTime',
                render: (h, params) =>{
                    return h('div', 
                        this.$PlugIn.formatDateTime(params.row.beginTime)
                    );
                }
            },
            {
                title: '结束时间',
                key: 'endTime',
                render: (h, params) =>{
                    return h('div', 
                        this.$PlugIn.formatDateTime(params.row.endTime)
                    );
                }
            },
            {
                title: '状态',
                key: 'gameState',
                render: (h, params) =>{
                    return h('div', 
                        this.gameStateF(params.row.gameState)
                    );
                }
            },
            {
                title: '状态修改时间',
                key: 'changeStateTime',
                render: (h, params) =>{
                    return h('div', 
                        this.$PlugIn.formatDateTime(params.row.changeStateTime)
                    );
                }
            },
             {
                title: '未审核数量',
                key: 'count',
                render: (h, params) =>{
                    return h('div', 
                        params.row.count ? params.row.count : '全部审核'
                    );
                }
            },
            {
                title: '操作',
                align: 'center',
                width: 306,
                render: (h, params) => {
                        return h('div',{
                            style: {
                                paddingTop: '6px',
                                paddingBottom: '6px',
                                
                            }
                        },[
                           
                            h('Button', {
                                props: {
                                    type: 'info',
                                    size: 'small',
                                },
                                style: {
                                    marginRight: '3px',
                                    display: JSON.parse(localStorage.authorities)==this.$PlugIn.role.admin ? 'inline-block' : 'none'
                                },
                                on: {
                                    click: () => {
                                    
                                        this.ModalSport = true;
                                        this.formValiEditDateSports = this.$PlugIn.deepClone(params.row);
                                        this.ModalSportTi = '编辑运动会';
                                        getEventListGameID(params.row.gameID).then(res => {

                                            if(res.data.code == 0){
                                               this.checkAllGroup = [];
                                               if( res.data.data )
                                               {
                                                    res.data.data.forEach((item)=>{
                                                        this.checkAllGroup.push(item.name);
                                                    });
                                               }
                                              

                                            }else if(res.data.code == -2){
                                                this.$Message.error("获取失败");
                                            }else if(res.data.code==10)
                                            {
                                                this.$Message.info("登录token过期请重新登录");
                                                this.$store.dispatch('loginOut');
                                            }else{
                                                this.$Message.error(res.data.msg);
                                            }
                                        },err =>{
                                            this.$Message.error("网络连接失败");
                                        });
                                    }
                                }
                            }, '编辑'),
                           
                             h('Button', {
                                props: {
                                    type: 'primary',
                                    size: 'small',
                                },
                                style: {
                                    marginRight: '3px',
                                },
                                on: {
                                    click: () => {
                                        
                                        this.setting.gameId = params.row.gameID;
                                        this.resultList.ModalResultList = true;
                                        this.sporterLimits = params.row.sporterLimit ? params.row.sporterLimit : 0;
                                        this.registerYear =  params.row.beginTime ? (this.$PlugIn.formatDateTime(params.row.beginTime)).substr(0,4) :'';
                                        this.GroupListData(1);
                                        this.$store.dispatch("getGameNames", params.row);

                                    }
                                }
                            }, '进入系统'),
                            h('Button', {
                                props: {
                                    type: 'info',
                                    size: 'small',
                                },
                                style: {
                                    marginRight: '3px',
                                    display: JSON.parse(localStorage.authorities)==this.$PlugIn.role.admin ? 'inline-block' : 'none'
                                },
                                on: {
                                    click: () => {
                                       this.AddInternal(params.row.gameID);
                                    }
                                }
                            }, '上传历史库'),
                            h('Select',{
                                props: {
                                    value: params.row.gameState,
                                    size:'small'
                                },
                                style:{
                                    width:'96px',
                                    textAlign:'left',
                                    display: JSON.parse(localStorage.authorities)==this.$PlugIn.role.admin ? 'inline-block' : 'none'
                                },
                                on: {
                                    'on-change':(e) => {
                                        if(params.row.gameState)
                                        {
                                            this.updatestateF(params.row.gameID,e); 
                                        }
                                    }
                                }
                            },
                            this.$PlugIn.gameState.map((item)=>{
                                return h('Option',{
                                    props:{
                                        value:item.value,
                                        label:item.label
                                    }
                                })
                            })
                            )
                        ]);

                }
            }
        ],         
        registerData: [],
        excelData: {//成绩导入Excel类型
            accept: "application/vnd.ms-excel"
        },
        ModalSportFilter:false,//筛选相似的运动会时间模态框
        registerDataFilter:[],//筛选相似的运动会
        registerColumnsFilter:[
            {
                type: 'selection',
                width: 40,
                align: 'center'
            },
            {
                type:'index',
                title: '序号',
                width:70,
                align:'center',

            },
            {
                title: '运动会名称',
                key: 'gameNameCHN',
                
            },
            {
                title: '比赛所在地名称',
                key: 'gameSiteCHN',
            },
            
            {
                title: '运动会开始时间',
                key: 'beginTime',
                width: 126,
                render: (h, params) =>{
                    return h('div', 
                        this.$PlugIn.formatDateTime(params.row.beginTime)
                    );
                }
            },
            {
                title: '运动会结束时间',
                key: 'endTime',
                width: 126,
                render: (h, params) =>{
                    return h('div', 
                        this.$PlugIn.formatDateTime(params.row.endTime)
                    );
                }
            },
           
        ],
    
    }
  },
  methods:{
        handleView () {
            this.visible = true;
        },
       handleCheckAll () 
       {
            if (this.indeterminate) 
            {
                this.checkAll = false;
            } else 
            {
                this.checkAll = !this.checkAll;
            }
            this.indeterminate = false;

            if (this.checkAll) 
            {
                this.checkAllGroup = [];
                this.eventLists.forEach((item)=>{
                    this.checkAllGroup.push(item.name);
                });
            } else 
            {
                this.checkAllGroup = [];
            }
        },
        checkAllGroupChange (data) 
        {
            if (data.length === 3) {
                this.indeterminate = false;
                this.checkAll = true;
            } else if (data.length > 0) {
                this.indeterminate = true;
                this.checkAll = false;
            } else {
                this.indeterminate = false;
                this.checkAll = false;
            }
        },
      historical()
      {
          redirectToken().then(res => {//新增
                if(res.data.code == 0){
                    console.log(res.data.data)
                    // this.historicalUrl = 'http://39.108.74.15:8001/#/searchLogin?token='+res.data.data;
                    this.historicalUrl = 'http://result.athletics.org.cn/#/searchLogin?token='+res.data.data;
                    setTimeout(()=>{
                        document.getElementById('historical').click();
                    },200)
                }else if(res.data.code == -2){
                    this.$Message.error("网络连接失败");
                }else if(res.data.code==10)
                {
                    this.$Message.info("登录token过期请重新登录");
                    this.$store.dispatch('loginOut');
                }else{
                    this.$Message.error(res.data.msg);
                }
            },err =>{
                this.$Message.error("网络连接失败");
            });
      },
      updatestateF(id,val)//更新录入状态
      {
            const state = {
                gameID:id,
                gameState:val
            }
            updatestate(state).then(res => {//新增
                if(res.data.code == 0){
                    this.$Message.info('状态更新成功');
                    this.getSportLists(this.pag);
                }else if(res.data.code == -2){
                    this.$Message.error("网络连接失败");
                }else if(res.data.code==10)
                {
                    this.$Message.info("登录token过期请重新登录");
                    this.$store.dispatch('loginOut');
                }else{
                    this.$Message.error(res.data.msg);
                }
            },err =>{
                this.$Message.error("网络连接失败");
            });
      },
      gameStateF(num)//录入状态
      {
          let str = '';
        if(num===1)
        {
            str  = "录入中";
        }else if(num===2)
        {
            str  = "审核中";
        }else if(num===3)
        {
            str  = "审核完成";
        }else if(num===4)
        {
            str  = "上传历史库";
        }
        return str;
      },
      AddInternal(gameID)
      {
        if(JSON.parse(localStorage.authorities)==this.$PlugIn.role.admin)
        {
            this.$Modal.confirm({
                title: '你确认要上传到历史库吗？',
                onOk: () => {
                    this.loadings();
                    internal(gameID).then(res => {//新增
                        if(res.data.code == 0){
                            this.$Message.info('成功上传');
                            this.$Spin.hide();
                        }else if(res.data.code == -2){
                            this.$Message.error("上传失败");
                            this.disableds = false;
                            this.$Spin.hide();
                        }else if(res.data.code==10)
                        {
                            this.$Message.info("登录token过期请重新登录");
                            this.$store.dispatch('loginOut');
                        }else{
                            this.$Message.error(res.data.msg);
                            this.$Spin.hide();
                        }
                    },err =>{
                        this.$Message.error("网络连接失败");
                    });
                    
                },
            
            });
        }
      },
      imageUrlUps()
      {
          this.resultFormObj.imageUrl = '';
      },
      SexsortregisterDataUps(data)
      {
          this.sexGroup.SexsortregisterData = data;
      },
      GroupregisterDataUps(data)
      {
          this.group.GroupregisterData = data;
      },
      showModalEventF()
      {
          this.eventList.ModalEvent = false;
      },
      ModalResultListShowF(){
        this.resultFormObj.ModalResultList = false;
      },
      groupListShowF1()
      {
          this.eventList.ModalEvent = false;
          this.sexGroup.ModalsexGroupList = true
      },
      groupListShowF()
      {
        this.sexGroup.ModalsexGroupList = false;
        this.group.ModalGroupList = true;
      },
      addSportF()
      {
        this.ModalSport=true;
        this.ModalSportTi = '新增运动会';
        this.setting.gameId='';
        
      },
      resultUp()
      {  
        this.resultListData = Date.parse(new Date());
      },
      resultShowF()
      {
          this.resultList.ModalResultList = true;
      },
      editOk(name)//新增运动会
      {
        this.$refs[name].validate((valid) => { 
            if (valid) {
                    this.updSporterData = {};
                    this.disableds = true;
                    let eventDataLists = [];
                    this.eventLists.forEach((item,key)=>{
                        this.checkAllGroup.forEach((obj,index)=>{
                            if(obj===item.name)
                            {
                                console.log(item,33)
                                eventDataLists.push(item);
                            }
                        })
                    });
                    this.updSporterData = this.$PlugIn.deepClone(this.formValiEditDateSports);
                    this.updSporterData.gameID = this.updSporterData.gameID ? this.updSporterData.gameID : -1;
                    this.updSporterData.beginTime = this.formValiEditDateSports.beginTime;
                    this.updSporterData.endTime = this.formValiEditDateSports.endTime;
                    this.updSporterData.eventLists = eventDataLists;
                    const findByGameName = {
                        beginTime:this.$PlugIn.formatDateTime(this.formValiEditDateSports.beginTime)
                    }
                    
                    if(!this.formValiEditDateSports.gameID)
                    {
                        this.findByGameNameOrBeginTimeF(1,findByGameName);
                    }else{
                        this.addSportListF(this.updSporterData);
                    }
                    
            } else {
                this.$Message.error('请完善信息');
                this.$Spin.hide();
            }
        });
      },
      startTimeChange1(e) { //运动会开始时间
        if(e)
        {
             this.starttime1 = e;
            this.formValiEditDateSports.beginTime = new Date(Date.parse(e));
        }
      },
      endTimeChange1(e) { //运动会结束时间
        if(e)
        {
        this.endtime1 = e;
        this.formValiEditDateSports.endTime = new Date(Date.parse(e));
        }

     },
     searchStartTime(e)
     {
         if(e)
         {
             this.formItem.beginTime = new Date(Date.parse(e));
         }
         
     },
     searchEndTime(e)
     {
         if(e)
         {
             this.formItem.endTime = new Date(Date.parse(e));
         }
         
     },
    // 点击复选框回调
    checkBoxs(val){
        this.multipleSelection = val // 返回的是选中的列的数组集合
    },
    //分页方法
    changepage(value) {
        this.pag.page_no = value
        this.getSportLists(this.pag);
    },
    getSportLists(pag)//获取运动会列表
    {
        
        getSportList(pag).then(res => {
            if(res.data.code == 0){
                let registerData = res.data.data.results;
                this.total_record = res.data.data.total_record;
                 let arr = [];
                registerData.forEach((item)=>{
                    arr.push(item.gameID);
                })
                countAuditInfo(arr).then(res2 => {
                    if(res2.data.code == 0){
                        res2.data.data&&res2.data.data.forEach((item,index)=>{
                            registerData[index].count = item.count;
                        });
                        this.registerData = registerData;
                        this.loading = false;

                    }else if(res2.data.code == -2){
                        this.$Message.error("获取失败");
                    }else if(res2.data.code==10)
                    {
                        this.$Message.info("登录token过期请重新登录");
                        this.$store.dispatch('loginOut');
                    }else{
                        this.$Message.error(res2.data.msg);
                    }
                },err =>{
                    this.$Message.error("网络连接失败");
                });
            }else if(res2.data.code == -2){
                this.$Message.error("获取失败");
            }else if(res2.data.code==10)
            {
                this.$Message.info("登录token过期请重新登录");
                this.$store.dispatch('loginOut');
            }else{
                this.$Message.error(res2.data.msg);
            }
        },err =>{
            this.$Message.error("网络连接失败");
        });
    },
    //去左右空格;
    trim(s)
    {
        return s.replace(/(^\s*)|(\s*$)/g, "");
    },
    //   搜索
    searchSubmit(){
       
        this.formItem.page_size = this.pag.page_size;
        this.formItem.gameNameCHN = this.trim(this.formItem.gameNameCHN);
        this.pag = this.formItem;
        this.getSportLists(this.formItem)
        this.pag.page_no = 1;
        

    },
    GroupListData(now)//获取组别列表
    {
        
          if(!now)
          {
              this.group.ModalGroupList=true;
          }
          
          getSort(this.setting.gameId).then(res => {
                if(res.data.code == 0){
                    this.group.GroupregisterData = res.data.data;
                }else if(res.data.code == -2){
                    this.$Message.error("网络连接失败");
                }else if(res.data.code==10)
                {
                    this.$Message.info("登录token过期请重新登录");
                    this.$store.dispatch('loginOut');
                }else{
                    this.$Message.error(res.data.msg);
                }
            },err =>{
                this.$Message.error("网络连接失败");
            });
    },
    sexGroupList(now)//获取比赛组别列表
    {
        
          if(!now)
          {
              this.sexGroup.ModalsexGroupList=true;
          }
          getSexsortList(this.setting.gameId).then(res => {
                if(res.data.code == 0){
                    this.sexGroup.SexsortregisterData = res.data.data;
                }else if(res.data.code == -2){
                    this.$Message.error("网络连接失败");
                }else if(res.data.code==10)
                {
                    this.$Message.info("登录token过期请重新登录");
                    this.$store.dispatch('loginOut');
                }else{
                    this.$Message.error(res.data.msg);
                }
            },err =>{
                this.$Message.error("网络连接失败");
            });
    },
    eventListShowFn()
    {
        this.sexGroup.ModalsexGroupList = false;
        this.eventList.ModalEvent = true;
        this.sexGroupList(1);
    },
    resultFormShowF(obj)
    {
        
        this.resultFormObj.ModalResultList = true;
        console.log(obj.sexType)
        this.resultFormObj.sexType = obj.sexType;
        if(obj.addData)
        {
            
            this.resultFormObj.sexSortEventLayerID = obj.sexSortEventLayerID;
            this.resultFormObj.sexSortEventID = obj.sexSortEventID;
            this.resultFormObj.layer = obj.layer;
            this.resultFormObj.event = obj.event;
            this.resultFormObj.addData = obj.addData;
             this.resultFormObj.up = obj.up;
        }else{
            if(obj.data.property===2||obj.data.allProp===2)
            {
                for(var item in obj.data)
                {
                    this.resultFormObj[item] = obj.data[item]
                }
                this.resultFormObj.up = obj.up;
                
                this.resultFormObj.details = obj.data.details;
               
            }else{
                this.resultFormObj.details = [];
                this.resultFormObj.items = [];
                for(var item in obj.data)
                {
                    this.resultFormObj[item] = obj.data[item]
                }
                this.resultFormObj.up = obj.up;
            }
            this.resultFormObj.addData = false;
            
        }
        
    },
    ModalsexGroupListF()
    {
        this.group.ModalGroupList = false;
        this.sexGroup.ModalsexGroupList = true;
        this.sexGroupList();
    },
    //查询运动会相近的时间
    findByGameNameOrBeginTimeF(types,findByGameName)
    {
        findByGameNameOrBeginTime(findByGameName).then(res => {//新增
            if(res.data.code == 0){
                
                if(!res.data.data.results.length)
                {
                    if(types===1)
                    {
                        this.addSportListF();
                    }
                      
                }else{
                    if(types===2)
                    {
                        this.$Message.info("该运动会已经存在");
                    }else{
                        this.$Message.info({
                            content:"匹配到"+res.data.data.results.length+"个运动会时间比较相近",
                            duration:4,
                        });
                        
                        this.ModalSportFilter = true;
                        this.registerDataFilter = res.data.data.results;
                    }
                  
                }
                
            }else if(res.data.code == -2){
                this.$Message.error("网络连接失败");
                this.disableds = false;
            }else if(res.data.code==10)
            {
                this.$Message.info("登录token过期请重新登录");
                this.$store.dispatch('loginOut');
            }else{
                this.$Message.error(res.data.msg);
                this.disableds = false;
            }
        },err =>{
            this.$Message.error("网络连接失败");
        });
    },
    filterGameNameCHN()
    {
        const gameNameCHN = {
            gameNameCHN:this.formValiEditDateSports.gameNameCHN
        }

        if(!this.formValiEditDateSports.gameID)
        {
            this.findByGameNameOrBeginTimeF(2,gameNameCHN);
        }
        
    },
    addSportListF()
    {
        this.loadings();
        addSportList(this.updSporterData).then(res => {//新增
            if(res.data.code == 0){
                this.$Message.info("保存成功");
                this.ModalSportFilter = false;
                this.formItem.gameNameCHN = '';
                this.timeFliter(this.stampTiem);
                this.getSportLists(this.pag);
                 this.ModalSport = false;
                this.disableds = false;
                this.setting.gameId = res.data.data;
                this.$Spin.hide();
                this.handleReset ('formValiEditDateSports');
            }else if(res.data.code == -2){
                this.$Message.error("添加失败");
                this.disableds = false;
                this.$Spin.hide();
            }else if(res.data.code==10)
            {
                this.$Message.info("登录token过期请重新登录");
                this.$store.dispatch('loginOut');
            }else{
                this.$Message.error(res.data.msg);
                this.disableds = false;
                this.$Spin.hide();
            }
        },err =>{
            this.$Message.error("网络连接失败");
        });
    }, 
    mergeSportF()
    {
        if(this.multipleSelection.length>1)
        {
            this.$Message.info("最多只能选择一个运动会");
        }else if(!this.multipleSelection.length)
        {
            this.$Message.info("最少要选择一个运动会");
        }else{
          this.mergeSport.mergeModal = true;
          this.mergeSport.obj = this.multipleSelection[0];
          this.mergeSport.mergeSportColumns = this.registerColumnsFilter;
        }
    },
    SportFilter()
    {
        if(this.multipleSelection.length>1)
        {
            this.$Message.info("最多只能选择一个运动会");
        }else if(!this.multipleSelection.length)
        {
            this.$Message.info("最少要选择一个运动会");
        }else{
            this.ModalSportFilter = false;
            this.ModalSport = false;
            this.formItem.gameNameCHN = this.multipleSelection[0].gameNameCHN;
            this.disableds = false;
            this.handleReset ('formValiEditDateSports');
            this.searchSubmit(); 
        }
    },
    timeFliter(time)
    {
        const endTime = time;
        const beginTime = endTime-(1000*3600*24*180);
        this.pag.beginTime = this.formItem.beginTime = new Date(Date.parse(this.$PlugIn.formatDateTime(beginTime)));
        this.pag.endTime =  this.formItem.endTime = new Date(Date.parse(this.$PlugIn.formatDateTime(endTime)));
        this.getSportLists(this.pag);
    },
    handleReset(name)
    {
        this.eventDefaultLists.forEach((item)=>{
            this.checkAllGroup.push(item.name);
        });
        // this.checkAllGroup = [];
        this.updSporterData = {};
        this.formValiEditDateSports.gameID = '';
        this.$refs[name].resetFields();
    },
    getEventList()
    {
        if(this.eventLists.length<1)
        {
            getEventList().then(res => {
                if(res.data.code == 0){
                    this.eventLists = res.data.data;
                    this.eventDefaultLists = res.data.data;
                    this.eventDefaultLists.forEach((item)=>{
                        this.checkAllGroup.push(item.name);
                    });
                }else if(res.data.code == -2){
                    this.$Message.error("获取失败");
                }else if(res.data.code==10)
                {
                    this.$Message.info("登录token过期请重新登录");
                    this.$store.dispatch('loginOut');
                }else{
                    this.$Message.error(res.data.msg);
                }
            },err =>{
                this.$Message.error("网络连接失败");
            }); 
        }
    },
    upSportData()
    {
        this.getSportLists(this.pag);
    }  
                        
  },
  created(){    
     this.getEventList();
  },
  mounted(){

      
      currentTimes().then( (response) => {
          if(response.data.code===0)
          {
              this.stampTiem = parseInt(response.data.data);
              this.timeFliter(this.stampTiem);
              this.stampTiemY = parseInt(this.$PlugIn.formatDateTime(this.stampTiem)) ;
              
          }else{
              this.$Message.warning('网络请求已经超时，请重新刷新页面');
          }
      }).catch((error) => {
      })
      

  }
}
</script>
<style scoped  lang="less">
.sporterEventList{padding-bottom: 32px;}
.sporterEventList .ivu-checkbox-default label{width:120px;padding-top: 6px;}
.page{
    
    .fromDiv{
      max-width: 1200px;
    }
    .ivu-date-picker{
      display: block;
    }
    .UpBut{
      padding-top: 22px;
      max-width: 1200px;
      button{min-width: 100px;}
    }
   
}

 .GroupUpBut{
        padding-top: 22px;
    }
.GroupListTable{max-height: 300px;overflow-y: auto}
/*定义滚动条的轨道，内阴影及圆角*/
.GroupListTable::-webkit-scrollbar-track{
  -webkit-box-shadow: inset 0 0 6px rgba(0,0,0,0.3);
  border-radius: 2px;
  background-color: #f5f5f5;
  
}
/*定义滑块，内阴影及圆角*/
.GroupListTable::-webkit-scrollbar-thumb{
  border-radius:2px;
  -webkit-box-shadow: inset 0 0 6px rgba(0,0,0,0.3);
  background-color:#ddd;
 
}

.GroupListTable::-webkit-scrollbar{
  width: 4px;
  background-color: #f5f5f5;
}
.exceluPloadBtn{height:32px;line-height: 32px;overflow: hidden;border-radius: 4px;cursor:pointer;}
.exceluPloadBtn input{opacity: 0;font-size: 0px;width:100%;height: 100%;display: block;left: 0;top: 0;cursor:pointer;}
.TableListMain{min-height: 500px;}
.note{padding:12px;color: red;}
.sportermeetingPage{margin-top:-100px;margin-bottom: 68px;z-index: 99;position: relative;}
#historical{display: none;}
</style>




// WEBPACK FOOTER //
// src/view/sportermeeting.vue